import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { SsoService } from "../../../services/sso.service";
import { XsMessageBoxComponent } from "../../../../common/widgets/xs-message-box/xs-message-box.component";

export interface LoginData {
  tipoDocumento: string;
  nroDocumento: string;
  clave: string;
}

@Component({
  selector: "app-xs-sub-login",
  templateUrl: "./xs-sub-login.component.html",
  styleUrls: ["./xs-sub-login.component.css"]
})

export class XsSubLoginComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<XsSubLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public loginData: LoginData,
    public usuarioService: SsoService,
    public dialog: MatDialog
  ) { }

  listaTipoDocumento = [
    { "id": "1", "nombre": "DNI" },
    { "id": "2", "nombre": "Carné de Extranjería" },
  ];

  ngOnInit() {
    this.loginData.tipoDocumento = '1';
  }

  onClickAceptar(): void {
    let error = this.validarFormulario();
    if (!error) {
      this.dialogRef.close({ data: null, estado: "ACEPTAR" });
    }
  }

  onClickCancelar(): void {
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  fakeData() {
    this.loginData.nroDocumento = '12345678';
    this.loginData.clave = '123456';
  }

  validarFormulario(): boolean {
    let mensaje = '';
    let tieneError = false;

    // if (!this.loginData.nroDocumento) {
    //   mensaje += 'Ingrese el número de documento'
    //   tieneError = true;
    // }

    // if (!this.loginData.clave && !tieneError) {
    //   mensaje += 'Ingrese la clave'
    //   tieneError = true;
    // }

    if (tieneError) {
      this.mostrarMensajeDialog(mensaje);
    }

    return tieneError;
  }

  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }
}
